<div class="row mb-2">
  <!-- You can add search/filter controls here later -->
</div>

<div class="main-card mb-3 card">
  <div
    class="card-header d-flex justify-content-between align-items-center font-weight-bold fs-1r"
  >
    <span>User Vehicle Search History</span>

    <!-- <span class="text-muted"> Total: {{ total }} </span> -->
  </div>

  <!-- Loader -->
  <div *ngIf="loading" class="text-center mt-5 mb-5">
    <i class="fa fa-spinner fa-spin fa-2x"></i>
    <div class="mt-2">Loading...</div>
  </div>

  <div class="table-responsive" *ngIf="!loading">
    <table
      class="align-middle mb-0 table table-borderless table-striped table-hover"
    >
      <thead>
        <tr class="align-middle">
          <th>#</th>

          <th>From</th>

          <th>To</th>

          <th>User Name</th>

          <th>Phone No</th>

          <th>Email</th>

          <!-- <th>Search Type</th> -->

          <th>Created On</th>

          <th class="text-end">Actions</th>
        </tr>
      </thead>

      <tbody>
        <tr
          *ngFor="let data of searchHistory; let i = index; trackBy: trackById"
        >
          <!-- Serial Number -->
          <td>
            {{ (page - 1) * limit + i + 1 }}
          </td>

          <!-- From -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <i class="fa fa-map-marker text-success mr-1"></i>

                    {{ data.search?.pickupLocationCity || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <!-- To -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    <i class="fa fa-map-marker text-danger mr-1"></i>

                    {{ data.search?.dropLocationCity || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <!-- User Name -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.user?.name || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <!-- Phone -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.user?.mobile || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <!-- Email -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.user?.email || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <!-- Search Type -->
          <!-- <td>
            <span class="badge badge-success" *ngIf="data.searchType">
              {{ data.searchType }}
            </span>

            <span *ngIf="!data.searchType"> - </span>
          </td> -->

          <!-- Created On -->
          <td>
            <div class="widget-content p-0">
              <div class="widget-content-wrapper">
                <div class="widget-content-left flex2">
                  <div class="widget-heading">
                    {{ data.createdAt | date: "dd MMM yyyy hh:mm a" : "en-IN" }}
                  </div>
                </div>
              </div>
            </div>
          </td>

          <!-- Actions -->
          <td class="text-end">
            <div class="dropdown">
              <button
                class="btn btn-info dropdown-toggle"
                type="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Action
              </button>

              <ul class="dropdown-menu">
                <li>
                  <a class="dropdown-item" (click)="viewDetails(data._id)">
                    View Details
                    <i class="fa fa-eye ml-1"></i>
                  </a>
                </li>
              </ul>
            </div>
          </td>
        </tr>

        <!-- No Data -->
        <tr *ngIf="searchHistory?.length === 0">
          <td colspan="9" class="text-center">
            <div class="text-danger mt-5 mb-5">Data Not found</div>
          </td>
        </tr>
      </tbody>
    </table>

    <!-- Pagination -->
    <div class="d-flex justify-content-end mt-3 mb-3" *ngIf="total > 0">
      <ngb-pagination
        (pageChange)="changePage((page = $event))"
        [collectionSize]="total"
        [(page)]="page"
        [pageSize]="limit"
        [maxSize]="3"
        [rotate]="true"
        [boundaryLinks]="false"
      >
      </ngb-pagination>
    </div>
  </div>
</div>
